//#region types
import { AuthEnums } from "models/enums";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function useFeatureService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getIsEnabled = (feature: string, authType: AuthEnums.AuthType) => {
    return apiClientInstance(authType)
      .FeatureClient.Get(feature)
      .then((res) => res.data.isEnabled);
  };

  const hasFeature = (feature: string) => getIsEnabled(feature, AuthEnums.AuthType.User);

  // A flag filtered per company is only evaluated when the request names the company.
  const hasCompanyFeature = (feature: string) => getIsEnabled(feature, AuthEnums.AuthType.Company);

  return {
    hasFeature,
    hasCompanyFeature,
  };
}

export default useFeatureService;
